'use client';

import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1] as const;

/**
 * Renders the final word "trust." statically with the gradient + underline.
 * Previously this slot-machined through ["count on.", "rely on.", "share.", "trust."]
 * but that was too much motion for the hero. Kept the component name + signature
 * so the call site in page.tsx doesn't need to change.
 */
export default function WordCycle({ delay = 0.46 }: { delay?: number }) {
  return (
    <span className="relative inline-block">
      <span className="block overflow-hidden pb-[0.22em] pr-[0.06em] align-bottom">
        <motion.span
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.72, ease: EASE, delay }}
          className="inline-block"
          style={{
            backgroundImage: 'linear-gradient(110deg,#7C3AED,#A78BFA,#6D28D9)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          trust.
        </motion.span>
      </span>

      {/* Underline — draws in once, then stays */}
      <motion.span
        aria-hidden
        className="absolute left-[0.04em] right-[0.18em] bottom-[0.04em] h-[0.06em] rounded-full origin-left"
        style={{ background: 'linear-gradient(90deg,#A78BFA,#7C3AED 55%,#6D28D9)' }}
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: 1 }}
        transition={{ duration: 0.85, ease: EASE, delay: delay + 0.5 }}
      />
    </span>
  );
}
